// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Pushpin = React.forwardRef(function Pushpin(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Pushpin" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M3 9.72327L9.72327 3C10.2672 3.5439 10.3291 4.97178 9.76773 5.53316L14.7909 9.59906C15.8986 8.87162 17.3768 8.97367 18.3226 9.91947L14.9832 13.2964L20.2865 18.5997L20.636 20.3715L18.8711 20.0151L13.5678 14.7118L10.1909 18.0512C9.24505 17.1054 9.14301 15.6272 9.87045 14.5195L5.80454 9.49635C5.24317 10.0577 3.5439 10.2672 3 9.72327Z", fill: "currentColor" }))));
});
Pushpin.displayName = 'Pushpin';
export default Pushpin;
//# sourceMappingURL=Pushpin.js.map